import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import { Button as MuiButton } from '@mui/material';

export const PasswordField = styled(TextField)`
  max-width: 300px;
`;

export const PasswordFieldWrapper = styled(Stack)({
  width: '100%',
  marginTop: '24px',
  gap: '12px',
  justifyContent: 'flex-end',
});

export const PasswordLabelStack = styled(Stack)({
  flexDirection: 'row',
  gap: '12px',
  alignItems: 'center',
  justifyContent: 'flex-start',
  maxWidth: '245px',
  width: '100%',
});

export const PasswordInputRow = styled(Stack)({
  flexDirection: 'row',
  gap: '24px',
  alignItems: 'center',
  width: '100%',
});

export const PasswordInputRowEndAligned = styled(Stack)({
  flexDirection: 'row',
  gap: '24px',
  justifyContent: 'flex-end',
  alignItems: 'center',
  width: '100%',
});

export const HeaderStack = styled(Stack)({
  flexDirection: 'row',
  gap: '12px',
});

export const ActionButtonStack = styled(Stack)({
  flexDirection: 'row',
  justifyContent: 'flex-end',
  gap: '12px',
});

export const ChangePasswordModal = styled(Modal)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& .MuiBackdrop-root': {
    backdropFilter: 'blur(6px)',
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
  },
});

export const PasswordLabelTypography = styled(Typography)(({ theme }) => ({
  textTransform: 'uppercase',
  color: theme.palette.white['06'],
  whiteSpace: 'nowrap',
  alignItems: 'center',
}));

export const CancelButton = styled(MuiButton)(({ theme }) => ({
  borderRadius: '32px',
  backgroundColor: theme.palette.error.main,
  fontSize: '12px',
  '&:hover': {
    backgroundColor: theme.palette.error.dark,
  },
}));

export const SubmitButton = styled(MuiButton)(({ theme }) => ({
  backgroundColor: theme.palette.primary['01'],
  borderRadius: '32px',
  fontSize: '12px',
  '&:hover': {
    backgroundColor: theme.palette.primary.main,
  },
}));
